import React from "react";
import { IoLogoAndroid } from "react-icons/io5";
import styles from "./ApkButton.module.scss";

interface ApkButtonProps {
  downloadUrl: string;
}

export const ApkButton: React.FC<ApkButtonProps> = ({ downloadUrl }) => {
  return (
    <a
      href={downloadUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.apkLink}
    >
      <div className={styles.apkButton}>
        <IoLogoAndroid className={styles.apkIcon} />
        <div className={styles.apkText}>
          <span className={styles.apkLabel}>Скачать для Android</span>
        </div>
      </div>
    </a>
  );
};